<template>
  <PubPage showProject @changeProject="changeProject">
    <BasicTable
      :columns="columns"
      bordered
      :dataSource="list"
      :scroll="{ x: 1000 }"
      :loading="loading"
      boxShadow
      :pagination="{
        current: form.paging.page,
        pageSize: form.paging.limit,
        total: pageTotal,
      }"
      @searchBack="searchBack"
      @pagesChange="pagesChange"
    >
      <!-- <template #tableTitle>
        <div class="pub-tableTitle-button">
          <a-button
            type="primary"
            class="btn-blue"
            ghost
            icon="download"
            @click="handleCreate"
          >
            导出原始记录
          </a-button>
        </div>
      </template> -->

      <template slot="index" slot-scope="{ index }">
        {{ index + 1 }}
      </template>
      <template slot="picture" slot-scope="{ record }">
        <BigImg :url="record.identifyImage" />
      </template>
      <template slot="syncStatus" slot-scope="{ record }">
        <div
          :style="{
            display: 'flex',
            'align-items': 'center',
            'justify-content': 'center',
          }"
        >
          <PubStatus :status="record.syncStatus" type="SYNC_STATUS" />
          <a-popover
            v-if="record.syncStatus == '1' && record.errorMsg"
            title="异常原因"
          >
            <template slot="content">
              {{ record.errorMsg }}
            </template>

            <a-icon
              :style="{ 'margin-left': '5px' }"
              type="question-circle"
              theme="twoTone"
              two-tone-color="#eb2f96"
            />
          </a-popover>
        </div>
      </template>
      <template slot="place" slot-scope="{ record }">
        <PubStatus :status="record.place" type="FACE_DEVICE_PLACE" />
      </template>
      <template slot="trafficDirection" slot-scope="{ record }">
        {{ record.trafficDirection | trafficDirectionFilter }}
      </template>
    </BasicTable>
  </PubPage>
</template>

<script>
import { Attendance } from "@/api";
import BigImg from "@/components/PublicModals/BigImg";

export default {
  components: { BigImg },
  data() {
    const columns = [
      {
        title: "序号",
        dataIndex: "index",
        align: "center",
        width: 50,
        hideInSearch: true,
        scopedSlots: true,
      },
      {
        title: "姓名",
        dataIndex: "personnelName",
        align: "center",
        width: 120,
      },
      {
        title: "宿舍名称",
        dataIndex: "dormitorySetName",
        align: "center",
        hideInSearch: true,
      },
      {
        title: "班级",
        dataIndex: "gradeClassName",
        hideInSearch: true,
      },
      {
        title: "班级",
        dataIndex: "gradeClassId",
        align: "center",
        hideInTable: true,
        valueType: "select",
        fieldProps: {
          placeholder: "请选择班级",
          option: () =>
            this.common.getAllClass(this.$store.state.user.schoolId),
        },
      },
      {
        title: "设备名称",
        dataIndex: "deviceName",
        hideInSearch: true,
        width: 120,
        align: "center",
      },
      {
        title: "设备地点",
        dataIndex: "place",
        align: "center",
        scopedSlots: true,
      },
      {
        title: "通行用途",
        dataIndex: "trafficDirection",
        hideInSearch: true,
        scopedSlots: true,
        width: 120,
        align: "center",
      },
      {
        title: "打卡时间",
        dataIndex: "identifyTime",
        hideInSearch: true,
        width: 160,
        align: "center",
      },
      {
        title: "照片",
        dataIndex: "picture",
        hideInSearch: true,
        scopedSlots: true,
        width: 80,
        align: "center",
      },
      {
        title: "进出时间",
        dataIndex: "time",
        valueType: "range",
        hideInTable: true,
        align: "center",
        fieldProps: {
          defaultValue: [],
          placeholder: "请选择日期",
          hideClear: true,
        },
      },
    ];
    return {
      form: {
        paging: {
          page: 1,
          limit: 20,
          sort: [
            {
              property: "createTime",
              direction: "DESC",
            },
          ],
        },
      },
      list: [],
      pageTotal: 0,
      loading: false,
      projectInfo: "",
      columns,
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 切换学校
    changeProject() {
      this.form.schoolId = this.$store.state.user.schoolId;
      this.getList();
    },
    // 获取数据
    getList() {
      this.loading = true;
      Attendance.faceRecordFindByPage(this.form).then(res => {
        if (res.code == this.config.pubCode) {
          this.list = res.data;
          this.pageTotal = res.total;
        }
        this.loading = false;
      });
    },
    // 翻页回调
    pagesChange(data) {
      this.form.paging.page = data.current;
      this.form.paging.limit = data.pageSize;
      this.getList();
    },
    // 搜索回调
    searchBack(data) {
      console.log(data);
      data.paging = {
        ...this.form.paging,
        page: 1,
        limit: this.form.paging.limit,
      };
      this.form = {
        ...this.form,
        ...data,
        startIdentifyTime: data.time && data.time.length ? data.time[0] : "",
        endIdentifyTime: data.time && data.time.length ? data.time[1] : "",
      };
      this.getList();
    },
  },
};
</script>
